<template>
  <div class="card shadow-sm border-0 rounded-custom">
    <div class="card-body p-4 p-lg-5">
      <h2 class="text-violet text-uppercase mb-3">{{ title }}</h2>
      <p class="text-muted mb-4">{{ description }}</p>

      <div class="mb-3">
        <label for="cam-operator" class="form-label fw-semibold">{{ $t("Operator") }}</label>
        <input
          id="cam-operator"
          :value="operatorName"
          type="text"
          class="form-control"
          disabled
          readonly
        />
      </div>

      <div class="mb-3">
        <label for="cam-logged-at" class="form-label fw-semibold">{{ $t("Registration date") }}</label>
        <input
          id="cam-logged-at"
          :value="loggedAtLabel"
          type="text"
          class="form-control"
          disabled
          readonly
        />
      </div>

      <div class="mb-3">
        <label for="milled-elements-count" class="form-label fw-semibold">
          {{ $t("Number of milled elements") }}
        </label>
        <input
          id="milled-elements-count"
          :value="form.milledElementsCount"
          type="number"
          min="1"
          step="1"
          class="form-control"
          :placeholder="$t('E.g. 12')"
          @input="emitNumberField('milledElementsCount', $event.target.value)"
        />
      </div>

      <div class="mb-3">
        <label for="cam-material" class="form-label fw-semibold">{{ $t("Material") }}</label>
        <select
          id="cam-material"
          :value="form.materialId"
          class="form-select"
          @change="emitNullableNumberField('materialId', $event.target.value)"
        >
          <option value="">{{ $t("Not specified") }}</option>
          <option v-for="material in materials" :key="material.id" :value="material.id">
            {{ material.name }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="cam-machine-name" class="form-label fw-semibold">{{ $t("Machine") }}</label>
        <input
          id="cam-machine-name"
          :value="form.machineName"
          type="text"
          class="form-control"
          maxlength="255"
          :placeholder="$t('Optional')"
          @input="emitTextField('machineName', $event.target.value)"
        />
      </div>

      <div class="mb-4">
        <label for="cam-notes" class="form-label fw-semibold">{{ $t("Notes") }}</label>
        <textarea
          id="cam-notes"
          :value="form.notes"
          rows="3"
          class="form-control"
          maxlength="2000"
          :placeholder="$t('Optional')"
          @input="emitTextField('notes', $event.target.value)"
        />
      </div>

      <div v-if="submitError" class="alert alert-danger">
        {{ submitError }}
      </div>

      <button class="btn btn-violet text-uppercase w-100" :disabled="!canSubmit || isSaving" @click="$emit('submit')">
        {{ isSaving ? $t("Saving...") : submitLabel }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CamProductionForm",
  props: {
    form: {
      type: Object,
      required: true,
    },
    materials: {
      type: Array,
      default: () => [],
    },
    operatorName: {
      type: String,
      default: "-",
    },
    loggedAtLabel: {
      type: String,
      default: "-",
    },
    canSubmit: {
      type: Boolean,
      default: false,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
    submitError: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Milled elements registration",
    },
    description: {
      type: String,
      default: "Enter the essential production data.",
    },
    submitLabel: {
      type: String,
      default: "Save record",
    },
  },
  emits: ["submit", "update-field"],
  methods: {
    emitNumberField(field, value) {
      const parsed = Number.parseInt(value, 10);
      this.$emit("update-field", field, Number.isInteger(parsed) ? parsed : null);
    },
    emitNullableNumberField(field, value) {
      if (value === "") {
        this.$emit("update-field", field, null);
        return;
      }

      const parsed = Number.parseInt(value, 10);
      this.$emit("update-field", field, Number.isInteger(parsed) ? parsed : null);
    },
    emitTextField(field, value) {
      this.$emit("update-field", field, value.trim());
    },
  },
};
</script>
